import { useUIStore } from '@uofu-uss-gis/ui-react';
import { useTheme } from '@mui/material/styles';
import { useAuthStore } from '../store/authStore';
import { env } from '../config/env';
import { loadOidcService } from '../services/oidcLoader';

const isLocalMode = env.localMode;

const MobileAppControls = () => {
  const { isAuthenticated, logout } = useAuthStore();
  const { myClassesOpen, setMyClassesOpen } = useUIStore();
  const theme = useTheme();

  const handleMyClassesClick = () => {
    if (isAuthenticated || isLocalMode) {
      setMyClassesOpen(true);
    } else {
      void loadOidcService().then(oidcService => oidcService?.login());
    }
  };

  const handleAuthClick = () => {
    if (isLocalMode) {
      setMyClassesOpen(true);
      return;
    }

    if (isAuthenticated) {
      logout();
    } else {
      void loadOidcService().then(oidcService => oidcService?.login());
    }
  };

  if (myClassesOpen) {
    return null;
  }

  return (
    <div
      className="absolute bottom-[30px] left-[15px] z-10 flex overflow-hidden rounded-lg shadow-lg lg:hidden"
      style={{ backgroundColor: theme.palette.background.paper }}
    >
      <button
        type="button"
        onClick={handleMyClassesClick}
        className="px-5 py-4 text-sm font-semibold hover:shadow-inner transition-shadow"
        style={{ color: theme.palette.text.primary }}
        aria-label={isAuthenticated ? 'Open My Classes' : 'Log in to My Classes'}
      >
        My Classes
      </button>
      <div className="w-px my-2" style={{ backgroundColor: theme.palette.divider }} />
      <button
        type="button"
        onClick={handleAuthClick}
        className="px-5 py-4 text-sm font-semibold hover:shadow-inner transition-shadow"
        style={{ color: theme.palette.text.primary }}
        aria-label={isAuthenticated ? 'Logout' : 'Log in'}
      >
        {isAuthenticated ? 'Logout' : 'Log In'}
      </button>
    </div>
  );
};

export default MobileAppControls;
